export default {
  install (Vue) {
    Vue.prototype.burry = function (event_id) {
      console.log(event_id)
      try {
        window.MtaH5.clickStat(event_id)
      } catch (error) {

      }
    }
    // const on = Vue.prototype.$on
    // // 防抖处理
    // Vue.prototype.$on = function (event, func) {
    //   let timer
    //   let newFunc = func
    //   if (event === 'click') {
    //     console.log(event, 'click')
    //     newFunc = function () {
    //       clearTimeout(timer)
    //       timer = setTimeout(function () {
    //         func.apply(this, arguments)
    //       }, 500)
    //     }
    //   }
    //   on.call(this, event, newFunc)
    // }
  }
}
